import React, { 
    createContext, 
    useEffect,
    useState, 
    useContext, 
    useCallback, 
    useMemo // Add this import
} from 'react';
import ToastMessage from '../components/toast-message/ToastMessage';
import axios from "axios";
import { Box } from '@mui/material';

// Create a context for toast management
const ToastContext = React.createContext(null);


export const ToastProvider = React.memo(({ children }) => {
    const [toasts, setToasts] = useState([]);

    const handleResendEmail = async (e) => {
        e.preventDefault(); 
        let emailValue = document.querySelector('input[name="email"]').value;
        var formData = new FormData();
        formData.append("email", emailValue);
      
        const config = {
          Headers: {
            "content-type": "application/json",
          },
        };
        await axios
        .post(
          `${process.env.REACT_APP_BASE_ADMIN_API}/auth/re-verify-account`,
          formData,
          config
        )
        .then((response) => {
          if (response?.data?.success) {
            addToast('success', "Link has been successfully sent")
          } else {
          }
        });
      };
    
      useEffect(() => {
        // Use setTimeout to ensure the DOM has updated before trying to attach the event listener
        const timer = setTimeout(() => {
          const link = document.getElementById('resend-link');
          if (link) {
            link.addEventListener('click', handleResendEmail);
          }
        }, 0)
    });

    // Memoize add and remove toast functions
    const addToast = useCallback((type, message) => {
        const id = Math.random().toString(36).substr(2, 9);
        setToasts(currentToasts => {
            // Prevent duplicate toasts
            const exists = currentToasts.some(
                toast => toast.type === type && toast.message === message
            );
            return exists 
                ? currentToasts 
                : [...currentToasts, { id, type, message }];
        });
        return id;
    }, []);

    const removeToast = useCallback((id) => {
        setToasts(currentToasts => 
            currentToasts.filter(toast => toast.id !== id)
        );
    }, []);

    // Memoize the context value
    const contextValue = useMemo(() => ({
        addToast,
        removeToast
    }), [addToast, removeToast]);

    return (
        <ToastContext.Provider value={contextValue}>
            {children}
            {toasts.length > 0 && (
                <Box 
                    className="toast-container" 
                    sx={{
                        position: 'fixed',
                        top: '50px',
                        right: {xs:'20px',sm:'40px'},
                        zIndex: 9999,
                        width: {xs:'100%',sm:'60%'},
                    }}
                >
                    {toasts.map(toast => (
                        <ToastMessage 
                            key={toast.id} 
                            type={toast.type}
                            message={toast.message}
                            onClose={() => removeToast(toast.id)}
                        />
                    ))}
                </Box>
            )}
        </ToastContext.Provider>
    );
});

// Custom hook
export const useToast = () => {
    const context = useContext(ToastContext);
    if (!context) {
        throw new Error('useToast must be used within a ToastProvider');
    }
    
    return useMemo(() => ({
        success: (message) => context.addToast('success', message),
        error: (message) => context.addToast('error', message),
        info: (message) => context.addToast('info', message),
        warning: (message) => context.addToast('warning', message)
    }), [context]);
};